export const BID_PRICE_USDT_CENTS = 10;

export const PRICE_INCREMENT_USDT_CENTS = 1;

export const TIMER_INITIAL_SEC = 60;
export const TIMER_INITIAL_MS = TIMER_INITIAL_SEC * 1000;
export const TIMER_EXTEND_MIN_SEC = 8;
export const TIMER_EXTEND_MAX_SEC = 15;
export const MIN_TIMER_AFTER_BID_SEC = 8;

export const LOT_CLOSE_GRACE_MS = 30_000;

// Trailing window for the hero "liveliest lot" signal: a bid counts toward
// recent_bids_60s while it's within this many ms of now.
export const LIVENESS_WINDOW_MS = 60_000;

export const LOT_CHAT_DELETE_AFTER_MS = 24 * 60 * 60 * 1000;

export const BID_PACKS = [
  { size: 50, discountPct: 0 },
  { size: 100, discountPct: 5 },
  { size: 250, discountPct: 10 },
  { size: 500, discountPct: 15 },
  { size: 1000, discountPct: 20 },
] as const;

export type BidPackSize = (typeof BID_PACKS)[number]['size'];

export const BID_PACK_SIZES = BID_PACKS.map((p) => p.size) as readonly BidPackSize[];

export const USDT_JETTON_DECIMALS = 6;

export const PAYMENT_INTENT_TTL_SEC = 3600;

export function bidPackAmountJettonUnits(size: BidPackSize): number {
  const pack = BID_PACKS.find((p) => p.size === size);
  if (!pack) throw new Error(`Unknown bid pack size: ${size}`);
  const grossCents = size * BID_PRICE_USDT_CENTS;
  const discountedCents = Math.round(grossCents * (100 - pack.discountPct)) / 100;
  return Math.round(discountedCents * 10 ** (USDT_JETTON_DECIMALS - 2));
}
